const PREFIXES = ["mr", "mrs", "ms", "miss", "dr", "prof"];
const SUFFIXES = ["jr", "sr", "ii", "iii", "iv"];

const normalize = (str) =>
  (str || "").toLowerCase().replace(/\./g, "").trim().replace(/\s+/g, " ");

const cleanParts = (str) => {
  const parts = normalize(str).split(" ").filter(Boolean);

  if (parts.length && PREFIXES.includes(parts[0])) parts.shift();
  if (parts.length && SUFFIXES.includes(parts[parts.length - 1])) parts.pop();

  return parts;
};

const levenshtein = (a = "", b = "") => {
  const m = a.length;
  const n = b.length;

  const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));

  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;

  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;

      dp[i][j] = Math.min(
        dp[i - 1][j] + 1, // delete
        dp[i][j - 1] + 1, // insert
        dp[i - 1][j - 1] + cost, // replace
      );
    }
  }

  return dp[m][n];
};

const isInitialMatch = (a = "", b = "") => {
  if (!a || !b) return false;
  return a[0] === b[0];
};

const isFuzzyMatch = (a = "", b = "", maxDistance = 1) => {
  if (!a || !b) return false;
  if (a === b) return true;

  const distance = levenshtein(a, b);
  return distance <= maxDistance;
};

const isFirstNameMatch = (a = "", b = "") => {
  if (!a || !b) return false;

  if (a === b) return true;

  // Jon vs Jonathan
  if (a.startsWith(b) || b.startsWith(a)) return true;

  // J vs John
  if (a.length === 1 || b.length === 1) return isInitialMatch(a, b);

  // small typo tolerance
  return isFuzzyMatch(a, b, 1);
};

const isLastNameMatch = (a = "", b = "") => {
  if (!a || !b) return false;

  if (a === b) return true;

  // allow tiny typo like Cole vs Coel only if very close
  return isFuzzyMatch(a, b, 1);
};

export const isVeryDifferent = (name1, name2) => {
  if (!name1 || !name2) return false;

  const n1Parts = cleanParts(name1);
  const n2Parts = cleanParts(name2);

  if (!n1Parts.length || !n2Parts.length) return false;

  const n1First = n1Parts[0];
  const n1Last = n1Parts[n1Parts.length - 1];

  const n2First = n2Parts[0];
  const n2Last = n2Parts[n2Parts.length - 1];

  const firstMatches = isFirstNameMatch(n1First, n2First);
  const lastMatches = isLastNameMatch(n1Last, n2Last);

  // only warn if first AND last are materially different
  return !(firstMatches && lastMatches);
};
